export const mobileFontSize = {
	caption: 11,
	meta: 12,
	body: 14,
	bodySmall: 13,
	title: 15,
	topBar: 16,
	topBarLarge: 17,
	metric: 20,
} as const;

export const mobileFontWeight = {
	regular: 400,
	medium: 500,
	semibold: 600,
} as const;

export const mobileLineHeight = {
	tight: 1.2,
	body: 1.35,
	relaxed: 1.45,
} as const;

export const mobileSpacing = {
	xxs: 4,
	xs: 6,
	sm: 8,
	md: 10,
	lg: 12,
	xl: 14,
	xxl: 16,
} as const;

export const mobileRadius = {
	sm: 6,
	md: 8,
	lg: 10,
	pill: 999,
} as const;

export const mobileShadow = {
	soft: '0 1px 2px rgba(15, 23, 42, 0.04)',
	raised: '0 6px 18px rgba(15, 23, 42, 0.08)',
	active: '0 0 0 2px rgba(255, 112, 67, 0.12)',
} as const;

export const mobileColor = {
	page: '#f5f6f8',
	surface: '#ffffff',
	surfaceMuted: '#f8fafc',
	border: '#e5e7eb',
	divider: '#eef0f3',
	text: '#20242b',
	textStrong: '#111827',
	textMuted: '#697386',
	textSubtle: '#8a94a6',
	primary: '#FF7043',
	primaryText: '#D2451E',
	primarySoft: '#fff0e8',
} as const;

export const mobileType = {
	caption: {
		fontSize: mobileFontSize.caption,
		fontWeight: mobileFontWeight.regular,
		lineHeight: mobileLineHeight.body,
	},
	meta: {
		fontSize: mobileFontSize.meta,
		fontWeight: mobileFontWeight.regular,
		lineHeight: mobileLineHeight.body,
	},
	body: {
		fontSize: mobileFontSize.body,
		fontWeight: mobileFontWeight.regular,
		lineHeight: mobileLineHeight.body,
	},
	bodyMedium: {
		fontSize: mobileFontSize.body,
		fontWeight: mobileFontWeight.medium,
		lineHeight: mobileLineHeight.body,
	},
	title: {
		fontSize: mobileFontSize.title,
		fontWeight: mobileFontWeight.medium,
		lineHeight: mobileLineHeight.tight,
	},
	topBar: {
		fontSize: mobileFontSize.topBar,
		fontWeight: mobileFontWeight.medium,
		lineHeight: mobileLineHeight.tight,
	},
	metric: {
		fontSize: mobileFontSize.metric,
		fontWeight: mobileFontWeight.semibold,
		lineHeight: mobileLineHeight.tight,
	},
} as const;
